module.exports = __webpack_public_path__ + "img/fifa21.bff68580.png";